import { ContextMenuItemRole } from "@microsoft/fast-components-react-base";
import manageJss from "@microsoft/fast-jss-manager-react";
import { ContextMenuItemStyles, } from "@microsoft/fast-components-styles-msft";
import contextMenuItemSchema from "./context-menu-item.schema";
import contextMenuItemSchema2 from "./context-menu-item.schema.2";
import MSFTContextMenuItem from "./context-menu-item";
const ContextMenuItem = manageJss(ContextMenuItemStyles)(MSFTContextMenuItem);
export { ContextMenuItem, ContextMenuItemRole, contextMenuItemSchema, contextMenuItemSchema2, };
